<template>
   <el-popover
	 		placement="top-start" 
			title="Date Tracking" 
			trigger="hover"
			@show="getApptStsLog()"
			>
			<div v-if="!onload">
				<div v-if="!_gHlp.isEmpty(listApptStatus)">
					<p v-for="historyItem in listApptStatus" :key="historyItem.id">
							<small>{{ historyItem.old_values.status_name }} <span v-if="historyItem.old_values.status_name">-></span> {{ historyItem.new_values.status_name }} at {{ historyItem.created_at }}</small>
					</p>
				</div>
				<div v-else>
					<small><i>No Logs</i></small>
				</div>
			</div>
			<div v-else>
				<small><i>load content...</i></small>
			</div>
			<div slot="reference" :style="{ backgroundColor: color }" class="circle"></div>
	</el-popover>
	
</template>
<script>
	import { Popover } from 'element-ui'
	import { useLeadStore } from '@/stores/leadStore'
	import { mapActions } from 'pinia'
  export default {
		props: ['lead_id','color','alt_color'],
    name: 'appt-circle-status-popover',
		components:{
			[Popover.name]: Popover
		},
    data() {
      return {
        listApptStatus: [],
				onload: false
      }
    },
		methods: {
        ...mapActions(useLeadStore, ['getApptStatusLog']),
				async getApptStsLog(){
					this.onload = true;
					this.listApptStatus = await this.getApptStatusLog(this.lead_id);
					this.listApptStatus.sort((a, b) => b.log_id - a.log_id)
					console.log(this.listApptStatus);
					this.onload = false;
				}
		}

  }
</script>
